import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'start-guide'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Single.vue'),
  meta: {
    auth: true,
  },
  permission: 'super.administer',
})

messageGroups.push(base)
